import request from "@/config/utils/request";
import { addUrlPerFix } from "@/basa/utils";

export function getAuthMenu(data) {
  return request({
    url: "apis/sp/app/getAuthMenu",
    method: "post",
    data
  });
}

export function getDetail(data) {
  return request({
    url: addUrlPerFix(process.env.VUE_APP_BASEP_URL) + "/apis/basap/getDetail",
    method: "post",
    data
  });
}

export function getLogin(data) {
  return request({
    url:
      addUrlPerFix(process.env.VUE_APP_BASEP_URL) +
      "/apis/basap/users/signup/getLogin",
    method: "post",
    data
  });
}

export function getAppToken(data) {
  return request({
    url: "/apis/sp/oauth2/codeRedirect",
    method: "post",
    data
  });
}

export function getCode(data) {
  return request({
    url:
      addUrlPerFix(process.env.VUE_APP_OAUTH_URL) +
      "?CLIENT_ID=100123&CALLBACK_URL=" +
      encodeURIComponent(window.location.href),
    method: "get",
    data
  });
}

export function getUserInfo(data) {
  return request({
    url:
      addUrlPerFix(process.env.VUE_APP_BASEP_URL) + "/apis/basap/getUserInfo",
    method: "post",
    data
  });
}

//更新黑名单信息
export function qrySupBlackList(data) {
  return request({
    url: "/apis/sp/smc/qrySupBlackList",
    method: "post",
    data
  });
}

//根据登录信息查询获取供应商信息
export function getSupInfoByLoginInfo(data) {
  return request({
    url: "/apis/sp/smc/getSupInfoByLoginInfo",
    method: "post",
    data
  });
}
